import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/my-training-course-list`;

export const myTrainingCourseListRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:trainingCourseId`,
} as const;

export type IMyTrainingCourseListRouteParams = IExtractRouteParamMap<
  typeof myTrainingCourseListRoutesObj
>;

export const myTrainingCourseListPath = createPaths<
  typeof myTrainingCourseListRoutesObj,
  IMyTrainingCourseListRouteParams
>(myTrainingCourseListRoutesObj);
